import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AiFillCloseCircle } from "react-icons/ai";
import { Slide } from "react-slideshow-image";
import colors from "../config/colors";
import CancelSharpIcon from "@mui/icons-material/CancelSharp";
import apiClient from "../api/apiClient";

export default () => {
  const [open, setopen] = useState(false);
  const [current, setCurrent] = useState();
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    document.title = "RollingAdz: Agency Packages" || "Default Title";
    fetchPackages();
  }, []);

  const fetchPackages = async () => {
    try {
      const response = await apiClient.get("/products/package/packages/");
      setPackages(response.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching packages:", error);
      setLoading(false);
    }
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      <div
        className="main pe-sm-4 ps-sm-4"
        style={{ height: "100vh", paddingTop: "2.3rem" }}
      >
        <div className="request-sec p-1">
          <div className="container " style={{ background: "#D4D4D4" }}>
            <div className="row roll-roz position-relative">
              <div className="col d-flex justify-content-between">
                <div className="" style={{ width: "130px" }}>
                  <Link to={"/"}>
                    <button className="bg-transparent border-0">
                      <CancelSharpIcon
                        style={{ color: "#005E9D", margin: "5px" }}
                        size={100}
                        color={colors.primary}
                      />
                    </button>
                  </Link>
                </div>
                <div className="text-center">
                  <h3 className="blue-clr p-3 fs-4">Our Packages!</h3>
                </div>
                <div>
                  <img
                    className="h-100 w-100"
                    src={require("../assets/img/rolling_roz.png")}
                    alt="logo"
                  />
                </div>
              </div>
            </div>

            <div className="row d-flex m-auto justify-content-between p-sm-2 p-1 pe-3 ">
              {packages.map((pkg) => (
                <div
                  key={pkg.id}
                  className="col-md-6 col-lg-4 d-flex justify-content-center mb-4"
                >
                  <div
                    className="card"
                    style={{
                      border: "1px solid #005E9D",
                      width: "87%",
                      borderRadius: "10px",
                    }}
                  >
                    <div
                      className="text-center"
                      style={{
                        backgroundColor: "#005E9D",
                        color: "white",
                        borderTopLeftRadius: "6px",
                        borderTopRightRadius: "6px",
                      }}
                    >
                      <h6
                        className="p-1"
                        style={{ margin: "3px", fontSize: "19px" }}
                      >
                        {pkg.package_name}
                      </h6>
                    </div>

                    <div className="card-body d-flex flex-column justify-content-between">
                      <div>
                        <div>
                          <img
                            src={pkg.image_url}
                            style={{ borderRadius: "13px" }}
                            width={"100%"}
                            height={"auto"}
                            className="card-img-top"
                            alt="..."
                          />
                        </div>
                        <p
                          className="card-title text-center pt-1"
                          style={{ fontSize: "12px", color: "#005E9D" }}
                        >
                          Average: {pkg.impression}
                        </p>
                        {pkg.month_info && pkg.price_info && (
                          <div className="row m-auto d-flex justify-content-center">
                            <div
                              className="col-4 text-center"
                              style={{ borderRight: "3px solid #005E9D" }}
                            >
                              <p
                                className="card-text"
                                style={{
                                  borderBottom: "3px solid #005E9D",
                                  fontWeight: "50px",
                                  paddingBottom: "4px",
                                  color: "#005E9D",
                                }}
                              >
                                Months
                              </p>
                              <p
                                className="card-text"
                                style={{ color: "#005E9D" }}
                              >
                                {pkg.month_info.first_month}
                              </p>
                              <p
                                className="card-text"
                                style={{ color: "#005E9D" }}
                              >
                                {pkg.month_info.second_month}
                              </p>
                              <p
                                className="card-text"
                                style={{ color: "#005E9D" }}
                              >
                                {pkg.month_info.third_month}
                              </p>
                            </div>
                            <div className="col-8 text-center">
                              <p
                                className="card-text"
                                style={{
                                  borderBottom: "3px solid #005E9D",
                                  paddingBottom: "4px",
                                  space: "nowrap",
                                  color: "#005E9D",
                                }}
                              >
                                Pricing(per month)
                              </p>
                              <div className="d-flex justify-content-center d-flex align-items-center pe-1">
                                <p
                                  style={{ color: "#005E9D" }}
                                  className="card-text"
                                >
                                  $ {pkg.price_info.first_month_price}
                                </p>
                                <p
                                  className="ps-2"
                                  style={{
                                    fontSize: "12px",
                                    color: "#1E71A8",
                                    fontWeight: "600",
                                  }}
                                >
                                  (Per{" "}
                                  {pkg.package_name.includes("TRUCK")
                                    ? "Truck"
                                    : "Car"}
                                  )
                                </p>
                              </div>
                              <div className="d-flex justify-content-center align-items-center pe-1">
                                <p
                                  style={{ color: "#005E9D" }}
                                  className="card-text"
                                >
                                  $ {pkg.price_info.second_month_price}
                                </p>
                                <p
                                  className="ps-2"
                                  style={{
                                    fontSize: "12px",
                                    color: "#1E71A8",
                                    fontWeight: "600",
                                  }}
                                >
                                  (Per{" "}
                                  {pkg.package_name.includes("TRUCK")
                                    ? "Truck"
                                    : "Car"}
                                  )
                                </p>
                              </div>
                              <div className="d-flex justify-content-center d-flex align-items-center pe-1">
                                <p
                                  style={{ color: "#005E9D" }}
                                  className="card-text"
                                >
                                  $ {pkg.price_info.third_month_price}
                                </p>
                                <p
                                  className="ps-2"
                                  style={{
                                    fontSize: "12px",
                                    color: "#1E71A8",
                                    fontWeight: "600",
                                  }}
                                >
                                  (Per{" "}
                                  {pkg.package_name.includes("TRUCK")
                                    ? "Truck"
                                    : "Car"}
                                  )
                                </p>
                              </div>
                            </div>
                            <div
                              className="m-auto pt-1 "
                              style={{ width: "79%" }}
                            >
                              {pkg.price_info.one_time_wrapping_charge && (
                                <p
                                  className="card-title text-center p-0 m-0"
                                  style={{
                                    fontSize: "12px",
                                    color: "#005E9D",
                                    fontFamily: "sans-serif",
                                  }}
                                >
                                  1 Time Wrapping Charge: $
                                  {pkg.price_info.one_time_wrapping_charge} Per{" "}
                                  {pkg.package_name.includes("TRUCK")
                                    ? "truck"
                                    : "car"}
                                </p>
                              )}
                              {pkg.price_info.minimum_purchase && (
                                <p
                                  className="card-title text-center "
                                  style={{
                                    fontSize: "12px",
                                    color: "#005E9D",
                                    fontFamily: "sans-serif",
                                  }}
                                >
                                  Minimum purchase:{" "}
                                  {pkg.price_info.minimum_purchase}{" "}
                                  {pkg.package_name.toLowerCase()}
                                </p>
                              )}
                            </div>
                          </div>
                        )}
                      </div>

                      <div className="text-center d-flex justify-content-center aling-items-center">
                        <Link
                          to="https://calendly.com/rolling-adz-specailist/meet-a-rolling-adz-brand-strategist"
                          className="btn"
                          style={{
                            backgroundColor: "#005E9D",
                            color: "white",
                            padding: "16px 25px",
                            fontSize: "13px",
                            fontWeight: "bold",
                          }}
                        >
                          GET STARTED
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div
              className="row mx-auto my-4 mt-1 mb-5"
              style={{
                backgroundColor: "white",
                border: "1px solid #005E9D ",
                borderRadius: "15px",
                width: "94%",
              }}
            >
              <div className="  mb-1 col-lg-4">
                <div
                  className=""
                  style={{
                    backgroundColor: "#005E9D",
                    borderTopLeftRadius: "10px",
                    borderBottomRightRadius: "10px",
                    width: "87%",
                  }}
                >
                  <h5
                    className="pt-2 pb-2 text-center "
                    style={{ color: "white" }}
                  >
                    DIGITAL RETARGETING
                  </h5>
                </div>
                <div className="text-center mt-3">
                  <p
                    className="card-text"
                    style={{
                      fontSize: "17px",
                      color: "#005E9D",
                      padding: "2px",
                      fontWeight: "500",
                      fontFamily: "sans-serif",
                    }}
                  >
                    Retargeting: $11.00 CPM
                  </p>
                  <p
                    className="card-text"
                    style={{
                      fontSize: "17px",

                      color: "#005E9D",
                      padding: "2px",
                      fontWeight: "500",
                    }}
                  >
                    (Minimum of 200K Impressions)
                  </p>
                  <div>
                    {" "}
                    <Link
                      className="btn"
                      to="https://calendly.com/rolling-adz-specailist/meet-a-rolling-adz-brand-strategist"
                      style={{
                        marginTop: "20px",
                        backgroundColor: "#005E9D",
                        color: "white",
                        padding: "16px  25px 16px 25px",
                        fontSize: "13px",
                        fontWeight: "bold",
                      }}
                    >
                      GET STARTED
                    </Link>
                  </div>
                </div>
              </div>
              <div className=" col-lg-8 pt-2 " style={{}}>
                <img
                  src={require("../assets/img/img.png")}
                  width={"100%"}
                  height={"100%"}
                  style={{
                    borderRadius: "14px",
                    overflow: "hidden",
                    paddingTop: "12px",
                    paddingBottom: "2px",
                  }}
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {current && (
        <>
          {current.type == "other" ? (
            <EventCard open={open} item={current} setopen={setopen} />
          ) : (
            <NewCard open={open} item={current} setopen={setopen} />
          )}
        </>
      )}
    </div>
  );
};

function NewCard({ open, setopen, item }) {
  function handleSubmit() {}

  return (
    <PopupWithButton
      title=""
      content={
        <div className="">
          <div className="d-flex justify-content-between align-items-center px-2 ">
            <div onClick={() => setopen(false)}>
              <AiFillCloseCircle size={30} color={colors.primary} />
            </div>
            <h3 className="text_color text-decoration-underline">
              Vehicle: {item.name}
            </h3>

            <div style={{ width: "8rem" }}>
              <img
                width={"100%"}
                src={require("../assets/img/rolling_roz.png")}
                alt=""
              />
            </div>
          </div>
          <div className="">
            <Slide>
              <div className="each-slide-effect">
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundSize: "cover",
                    height: "250px",
                    backgroundImage: `url(${item.Image})`,
                  }}
                >
                  {/* <span>Slide 1</span> */}
                </div>
              </div>
            </Slide>
          </div>
          {/* <img className="card_img_top img-fluid" src={item.Image} alt="Card image" style={{width: '100%', height: 'auto'}} /> */}
          <div className="box_bg p-3 border border-secondary rounded mt-2">
            <h5 className="text_color text-decoration-underline">
              Vehicle Info:
            </h5>
            <div className="row">
              <div className="col-md-4">
                <h6 className="text-muted">Avg.Impression:</h6>

                <p className="fs_14px">{item.Vehicle_info.avg_imp}</p>
                {item.Vehicle_info.ad_space && (
                  <div>
                    <h6 className="text-muted">Ad Space</h6>
                    <p className="fs_14px">{item.Vehicle_info.ad_space}</p>
                  </div>
                )}
                {item.Vehicle_info.fule_type && (
                  <div>
                    <h6 className="text-muted">Fuel Type</h6>
                    <p className="fs_14px">{item.Vehicle_info.fule_type}</p>
                  </div>
                )}
              </div>

              <div className="col-md-4">
                <h6 className="text-muted">Dimensions:</h6>
                {item.Vehicle_info.dimenstions.map((subitem, index) => (
                  <p key={index} className="fs_14px">
                    {subitem}
                  </p>
                ))}
              </div>
              <div className="col-md-4">
                <h6 className="text-muted">Sold By:</h6>{" "}
                {item.Vehicle_info.sold_by.map((subitem, index) => (
                  <div key={index} className="p-1">
                    <input type="checkbox" disabled checked name="" id="" />

                    <label className="fs_14px ps-1" htmlFor="">
                      {subitem}
                    </label>
                  </div>
                ))}
              </div>
            </div>
            <h5 className="text_color text-decoration-underline">
              Vehicle KPI's:
            </h5>
            <div className="row">
              <div className="col-md-4">
                <h6 className="text-muted">Best Uses:</h6>

                {item.Vehicle_KPI.best_user.map((subitem, index) => (
                  <p key={index} className="fs_14px m-0">
                    {subitem}
                  </p>
                ))}
              </div>

              <div className="col-md-4">
                <h6 className="text-muted">Local Drivers:</h6>

                {item.Vehicle_KPI.local_drivers.map((sub, index) => (
                  <p key={index} className="fs_14px m-0">
                    {sub}
                  </p>
                ))}
              </div>

              <div className="col-md-4">
                <h6 className="text-muted">Routes:</h6>
                {item.Vehicle_KPI.routes.map((subitem, index) => (
                  <p key={index} className="fs_14px m-0">
                    {subitem}
                  </p>
                ))}
              </div>
            </div>

            <h5 className="text_color text-decoration-underline">
              Drive Time:
            </h5>
            <div className="row">
              <div className="col-md-4">
                <h6 className="text-muted">Hours:</h6>
                <p>{item.drive_time.hours}</p>
              </div>

              <div className="col-md-4">
                <h6 className="text-muted">Days:</h6>
                <p className="fs_14px">{item.drive_time.days}</p>
              </div>
              <div className="col-md-4">
                <h6 className="text-muted">Months:</h6>
                <p className="fs_14px">{item.drive_time.months}</p>
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-center align-items-center gap-1 mt-2">
            {/* <div>
      <input min={0} type="number" name="" id="" style={{width:"4rem", height:"3rem"}} placeholder="0 Qty"/>
      </div> */}
            <div>
              <button className="btn btn_bg px-4 py-3">
                View Packages
                {/* <FaShoppingCart size={25} style={{paddingLeft:"5px"}}/> */}
              </button>
            </div>
          </div>
        </div>
      }
      isOpen={open}
      // loading={loading}
      yesName=""
      yesClick={handleSubmit}
      cancelName=""
      cancelClick={() => setopen(false)}
    />
  );
}

function EventCard({ open, setopen, item }) {
  function handleSubmit() {}

  return (
    <PopupWithButton
      title=""
      content={
        <>
          <div className="d-flex justify-content-between align-items-center px-2">
            <div onClick={() => setopen(false)}>
              <AiFillCloseCircle size={30} color={colors.primary} />
            </div>
            <h3 className="text_color text-decoration-underline">
              {item.name}
            </h3>
            <div style={{ width: "8rem" }}>
              <img
                width={"100%"}
                src={require("../assets/img/rolling_roz.png")}
                alt=""
              />
            </div>
          </div>
          <Stack>
            <Slide>
              <div className="each-slide-effect">
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundSize: "cover",
                    height: "250px",
                    backgroundImage: `url(${item.Image})`,
                  }}
                >
                  {/* <span>Slide 1</span> */}
                </div>
              </div>
            </Slide>
          </Stack>
          <div className="box_bg p-3 border border-secondary rounded mt-2">
            <h5 className="text_color text-decoration-underline">
              Product Description:
            </h5>
            <p>{item.description}</p>
          </div>
          <div className="d-flex justify-content-center align-items-center mt-2">
            {/* <div>
        <input min={0} type="number" name="" id="" style={{width:"4rem", height:"3rem"}} placeholder="0 Qty"/>
        </div> */}
            <div>
              <button className="btn btn_bg px-4 py-3">
                View Packages
                {/* <FaShoppingCart size={25} style={{paddingLeft:"5px"}}/> */}
              </button>
            </div>
          </div>
        </>
      }
      isOpen={open}
      // loading={loading}
      yesName=""
      yesClick={handleSubmit}
      cancelName=""
      cancelClick={() => setopen(false)}
    />
  );
}
